import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7f3306bd"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "q-mb-md"
}
const _hoisted_2 = { class: "row justify-between" }
const _hoisted_3 = { class: "col-4 q-mb-sm q-pr-sm" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, " * Moisture Water (ppm) ", -1 /* HOISTED */))
const _hoisted_5 = { class: "col-4 q-mb-sm q-px-sm" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, " * Dissolved gas hydrogen (ppm) ", -1 /* HOISTED */))
const _hoisted_7 = { class: "col-4 q-mb-sm q-px-sm" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, " * Dissolved gas methane (ppm) ", -1 /* HOISTED */))
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col-4 q-mb-sm q-pr-sm" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, " * Dissolved gas acethylene (ppm) ", -1 /* HOISTED */))
const _hoisted_12 = { class: "col-4 q-mb-sm q-px-sm" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, " * Dissolved gas ethylene (ppm) ", -1 /* HOISTED */))
const _hoisted_14 = { class: "col-4 q-mb-sm q-px-sm" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, " * Dissolved gas ethane (ppm) ", -1 /* HOISTED */))
const _hoisted_16 = { class: "row" }
const _hoisted_17 = { class: "col-4 q-mb-sm q-pr-sm" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, " * Dissolved gas monoxide (ppm) ", -1 /* HOISTED */))
const _hoisted_19 = { class: "col-4 q-mb-sm q-pr-sm" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, " * Dissolved gas dioxide (ppm) ", -1 /* HOISTED */))
const _hoisted_21 = { class: "col-4 q-mb-sm q-pr-sm" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, " * Dissolved gas TDCG* (ppm) ", -1 /* HOISTED */))
const _hoisted_23 = {
  key: 1,
  class: "q-mb-md"
}
const _hoisted_24 = { class: "row" }
const _hoisted_25 = { class: "col-4 q-mb-sm q-px-sm" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, " * Mean (M) ", -1 /* HOISTED */))
const _hoisted_27 = { class: "col-4 q-mb-sm q-px-sm" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, " * Standard deviation (SD)", -1 /* HOISTED */))
const _hoisted_29 = { class: "col" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, " Ratio (SD/M) ", -1 /* HOISTED */))
const _hoisted_31 = { class: "q-mt-sm q-ml-md" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_input = _resolveComponent("q-input")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.informationType === _ctx.informationTypeEnum.OIL)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              _createVNode(_component_q_input, {
                modelValue: _ctx.oilAnalysis.elecMoistureWater,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.oilAnalysis.elecMoistureWater) = $event)),
                class: "analysis",
                type: "number",
                step: "0.1",
                readonly: _ctx.isReadOnly,
                required: "",
                outlined: "",
                dense: ""
              }, null, 8 /* PROPS */, ["modelValue", "readonly"])
            ]),
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createVNode(_component_q_input, {
                modelValue: _ctx.oilAnalysis.elecDissolvedGasHydrogen,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.oilAnalysis.elecDissolvedGasHydrogen) = $event)),
                type: "number",
                class: "analysis",
                step: "0.1",
                readonly: _ctx.isReadOnly,
                required: "",
                outlined: "",
                dense: ""
              }, null, 8 /* PROPS */, ["modelValue", "readonly"])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _createVNode(_component_q_input, {
                modelValue: _ctx.oilAnalysis.elecDissolvedGasMethane,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.oilAnalysis.elecDissolvedGasMethane) = $event)),
                class: "analysis",
                type: "number",
                step: "0.1",
                readonly: _ctx.isReadOnly,
                required: "",
                outlined: "",
                dense: ""
              }, null, 8 /* PROPS */, ["modelValue", "readonly"])
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _hoisted_11,
              _createVNode(_component_q_input, {
                modelValue: _ctx.oilAnalysis.elecDissolvedGasAcethylene,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.oilAnalysis.elecDissolvedGasAcethylene) = $event)),
                class: "analysis",
                type: "number",
                step: "0.1",
                readonly: _ctx.isReadOnly,
                required: "",
                outlined: "",
                dense: ""
              }, null, 8 /* PROPS */, ["modelValue", "readonly"])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _hoisted_13,
              _createVNode(_component_q_input, {
                modelValue: _ctx.oilAnalysis.elecDissolvedGasEthylene,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.oilAnalysis.elecDissolvedGasEthylene) = $event)),
                class: "analysis",
                type: "number",
                step: "0.1",
                readonly: _ctx.isReadOnly,
                required: "",
                outlined: "",
                dense: ""
              }, null, 8 /* PROPS */, ["modelValue", "readonly"])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _hoisted_15,
              _createVNode(_component_q_input, {
                modelValue: _ctx.oilAnalysis.elecDissolvedGasEthane,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.oilAnalysis.elecDissolvedGasEthane) = $event)),
                class: "analysis",
                type: "number",
                step: "0.1",
                readonly: _ctx.isReadOnly,
                required: "",
                outlined: "",
                dense: ""
              }, null, 8 /* PROPS */, ["modelValue", "readonly"])
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _hoisted_18,
              _createVNode(_component_q_input, {
                modelValue: _ctx.oilAnalysis.elecDissolvedGasMonoxide,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.oilAnalysis.elecDissolvedGasMonoxide) = $event)),
                class: "analysis",
                type: "number",
                step: "0.1",
                readonly: _ctx.isReadOnly,
                required: "",
                outlined: "",
                dense: ""
              }, null, 8 /* PROPS */, ["modelValue", "readonly"])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _hoisted_20,
              _createVNode(_component_q_input, {
                modelValue: _ctx.oilAnalysis.elecDissolvedGasDioxide,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.oilAnalysis.elecDissolvedGasDioxide) = $event)),
                class: "analysis",
                type: "number",
                step: "0.1",
                readonly: _ctx.isReadOnly,
                required: "",
                outlined: "",
                dense: ""
              }, null, 8 /* PROPS */, ["modelValue", "readonly"])
            ]),
            _createElementVNode("div", _hoisted_21, [
              _hoisted_22,
              _createVNode(_component_q_input, {
                modelValue: _ctx.oilAnalysis.elecDissolvedGasTdcg,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.oilAnalysis.elecDissolvedGasTdcg) = $event)),
                class: "analysis",
                type: "number",
                step: "0.1",
                readonly: _ctx.isReadOnly,
                required: "",
                outlined: "",
                dense: ""
              }, null, 8 /* PROPS */, ["modelValue", "readonly"])
            ])
          ])
        ]))
      : _createCommentVNode("v-if", true),
    (_ctx.informationType === _ctx.informationTypeEnum.INSULATION)
      ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("div", _hoisted_25, [
              _hoisted_26,
              _createVNode(_component_q_input, {
                modelValue: _ctx.insulationAnalysis.mean,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.insulationAnalysis.mean) = $event)),
                class: "analysis",
                type: "number",
                step: "0.1",
                readonly: _ctx.isReadOnly,
                required: "",
                outlined: "",
                dense: "",
                onChange: _ctx.onChangeInsulationParams
              }, null, 8 /* PROPS */, ["modelValue", "readonly", "onChange"])
            ]),
            _createElementVNode("div", _hoisted_27, [
              _hoisted_28,
              _createVNode(_component_q_input, {
                modelValue: _ctx.insulationAnalysis.standardDeviation,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.insulationAnalysis.standardDeviation) = $event)),
                class: "analysis",
                type: "number",
                step: "0.1",
                readonly: _ctx.isReadOnly,
                required: "",
                outlined: "",
                dense: "",
                onChange: _ctx.onChangeInsulationParams
              }, null, 8 /* PROPS */, ["modelValue", "readonly", "onChange"])
            ]),
            _createElementVNode("div", _hoisted_29, [
              _hoisted_30,
              _createElementVNode("div", _hoisted_31, [
                _createVNode(_component_q_input, {
                  modelValue: _ctx.insulationAnalysis.ratioMeanStandardDeviation,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.insulationAnalysis.ratioMeanStandardDeviation) = $event)),
                  class: "ratio",
                  type: "number",
                  disabled: ""
                }, null, 8 /* PROPS */, ["modelValue"])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}